/**
 * GoNOW API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 2020-12-7
 * Contact: info@zero-spec.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CompanyResponse from './CompanyResponse';
import Options from './Options';

/**
* The SearchCompaniesResponse model module.
* @module model/SearchCompaniesResponse
* @version 2020-12-7
*/
export default class SearchCompaniesResponse {
    /**
    * Constructs a new <code>SearchCompaniesResponse</code>.
    * 会社検索レスポンス
    * @alias module:model/SearchCompaniesResponse
    * @class
    * @param companies {Array.<module:model/CompanyResponse>} 会社
    * @param result {module:model/SearchCompaniesResponse.ResultEnum} 
    */

    constructor(companies, result) {
        
        
        this['companies'] = companies;
        this['result'] = result;
        
    }

    /**
    * Constructs a <code>SearchCompaniesResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SearchCompaniesResponse} obj Optional instance to populate.
    * @return {module:model/SearchCompaniesResponse} The populated <code>SearchCompaniesResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SearchCompaniesResponse();
                        
            
            if (data.hasOwnProperty('companies')) {
                obj['companies'] = ApiClient.convertToType(data['companies'], [CompanyResponse]);
            }
            if (data.hasOwnProperty('result')) {
                obj['result'] = ApiClient.convertToType(data['result'], 'String');
            }
            if (data.hasOwnProperty('options')) {
                obj['options'] = Options.constructFromObject(data['options']);
            }
        }
        return obj;
    }

    /**
    * 会社
    * @member {Array.<module:model/CompanyResponse>} companies
    */
    'companies' = undefined;
    /**
    * @member {module:model/SearchCompaniesResponse.ResultEnum} result
    */
    'result' = undefined;
    /**
    * @member {module:model/Options} options
    */
    'options' = undefined;



    /**
    * Allowed values for the <code>result</code> property.
    * @enum {String}
    * @readonly
    */
    static ResultEnum = {
        /**
         * value: "NG"
         * @const
         */
        "NG": "NG",
        /**
         * value: "OK"
         * @const
         */
        "OK": "OK"    };

}
